<div class="left-content" [class.mobile]="isMobileResolution">
    <!-- Rotation images section -->
    <div class="rotation-section" *ngIf="!isMobileResolution" [class.mobile]="isMobileResolution" 
         (mouseenter)="stopImageRotation()" 
         (mouseleave)="restartImageRotation()">
        <img [src]="currentRotationImage" class="rotation-image" [class.mobile]="isMobileResolution" [alt]="'Rotation image ' + (currentImageIndex + 1)">
        <img src="assets/images/mc-logo.svg" class="mc-logo-overlay" [class.mobile]="isMobileResolution" alt="MyChart Logo">
        <div class="rotation-text-overlay" [class.mobile]="isMobileResolution">{{preloginHeadline}}</div>
        <div class="rotation-indicators" [class.mobile]="isMobileResolution" *ngIf="rotationImages.length > 1">
            <span *ngFor="let image of rotationImages; let i = index" 
                  class="indicator" 
                  [class.active]="i === currentImageIndex"
                  [class.mobile]="isMobileResolution"
                  (click)="setCurrentImage(i)">
            </span>
        </div>
        <div class="footer-overlay" [class.mobile]="isMobileResolution">
            <div class="overlay-item-left">
                <ul *ngFor="let feature of preloginFeatures">
                    <li>{{feature}}</li>
                </ul>
            </div>
            <div class="overlay-item-center" style="width: 160px;">
                {{preloginDownloadAppHeader}}
            </div>
            <div class="overlay-item-right">
                <div class="qr-code-container">
                    <div class="qr-code-item">
                        <img src="assets/images/barcode.svg" alt="App Store QR Code" class="qr-code-image">
                    </div>
                </div>
                <div class="qr-code-description">
                    {{preloginDownloadAppDetail}}
                </div>
            </div>
        </div>
    </div>
    <!-- Buttons section -->
    <div class="buttons-section" [class.mobile]="isMobileResolution">
        <!-- Button 1 -->
        <div class="button-div button-1 link" [class.mobile]="isMobileResolution" (click)="onGetCareNow()">
            <div class="button-image">
                <img src="assets/images/hand-cross-icon.svg" class="care-now-icon">
            </div>
            <div class="button-text" [class.mobile]="isMobileResolution">{{getCareNow}}</div>
            <div class="button-right-icon">
                <img src="assets/images/right-arrow-light-icon.svg" class="right-arrow-icon">
            </div>
        </div>
        <!-- Button 2 -->
        <div class="button-div button-2 link" [class.mobile]="isMobileResolution" (click)="onProviderSearch()">
            <div class="button-image">
                <img src="assets/images/magnifying-cross-icon.svg" class="find-provider-icon">
            </div>
            <div class="button-text" [class.mobile]="isMobileResolution">{{findAProvider}}</div>
            <div class="button-right-icon">
                <img src="assets/images/right-arrow-light-icon.svg" class="right-arrow-icon">
            </div>
        </div>
        <!-- Button 3 -->
        <div class="button-div button-3 link" [class.mobile]="isMobileResolution" (click)="onLocationSearch()">
            <div class="button-image">
                <img src="assets/images/building-icon.svg" class="button-image-prefix">
            </div>
            <div class="button-text" [class.mobile]="isMobileResolution">{{findALocation}}</div>
            <div class="button-right-icon">
                <img src="assets/images/right-arrow-light-icon.svg" class="right-arrow-icon">
            </div>
        </div>
    </div>
    <div class="image-mobile-section" *ngIf="isMobileResolution">
        <div class="mobile-left-pane">
            <img src="assets/images/mobile-rotation-img.svg" alt="Mobile App Preview" />
        </div>
        <div class="mobile-right-pane">
            <h3 class="mobile-right-title">{{preloginHeadline}}</h3>
            <ul class="mobile-right-bullets">
                <li *ngFor="let feature of preloginFeatures">{{feature}}</li>
            </ul>
            <div class="mobile-right-footer">{{preloginDownloadAppHeaderLine1}}</div>
           <div class="mobile-right-footer">{{preloginDownloadAppHeaderLine2}}</div>    
        </div>
    </div>
</div>